import { ethers } from "ethers";
import { unref } from "vue";

const roundN = (value: number, digits: number) => {
  const tenToN = 10 ** digits;
  return Math.round(value * tenToN) / tenToN;
};

export default (value: ethers.BigNumber | number | string, digits = 4) => {
  let _value = unref(value);

  if (_value instanceof ethers.BigNumber) {
    _value = ethers.utils.formatEther(_value);
  }

  if (typeof _value === "string") {
    _value = Number(_value);
  }
  return roundN(_value, digits);
};
